import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { config } from '../../config/jewelleryLandingConfig';
import SafeIcon from '../../common/SafeIcon';
import { FiMenu, FiX } from 'react-icons/fi';

const scrollToContact = () => {
  const contactSection = document.getElementById('contact');
  if (contactSection) {
    contactSection.scrollIntoView({ behavior: 'smooth' });
  }
};

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <motion.nav 
      initial={{ y: -100 }} 
      animate={{ y: 0 }} 
      className={`fixed w-full z-50 transition-all duration-500 ease-in-out ${
        scrolled ? 'bg-white/80 backdrop-blur-xl shadow-premium py-4 border-b border-champagne/40' : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center">
        {/* Premium Brand Mark */}
        <a href="#" className="flex items-center gap-3 group">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-espressoDeep to-espresso flex items-center justify-center shadow-goldGlow border border-gold/30 group-hover:scale-105 transition-transform">
            <span className="text-gold font-serif text-xl">B</span>
          </div>
          <div className="flex flex-col">
            <span className="text-xl font-serif tracking-wide text-espresso leading-none">
              {config.brand.name}
            </span>
            <span className="text-[9px] uppercase tracking-[0.2em] text-mutedGold mt-1">
              Jewellery Visual Studio
            </span>
          </div>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-10">
          <a href="#proof" className="text-xs font-semibold tracking-widest uppercase text-espresso/80 hover:text-gold transition-colors">
            Proof
          </a>
          <a href="#process" className="text-xs font-semibold tracking-widest uppercase text-espresso/80 hover:text-gold transition-colors">
            Process
          </a>
          <a href="#challenges" className="text-xs font-semibold tracking-widest uppercase text-espresso/80 hover:text-gold transition-colors">
            Solutions
          </a>
          <button 
            onClick={scrollToContact}
            className="luxury-gold-button px-6 py-2.5"
          >
            Request a Visual Sample
          </button>
        </div>

        {/* Mobile Toggle */}
        <button 
          className="md:hidden text-espresso" 
          onClick={() => setIsOpen(!isOpen)} 
          aria-label="Toggle Menu"
        >
          <SafeIcon icon={isOpen ? FiX : FiMenu} className="w-6 h-6" />
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-paper shadow-luxury py-6 px-6 flex flex-col space-y-6 border-b border-champagne/50">
          <a href="#proof" onClick={() => setIsOpen(false)} className="text-sm tracking-widest uppercase text-espresso">
            Proof
          </a>
          <a href="#process" onClick={() => setIsOpen(false)} className="text-sm tracking-widest uppercase text-espresso">
            Process
          </a>
          <a href="#challenges" onClick={() => setIsOpen(false)} className="text-sm tracking-widest uppercase text-espresso">
            Solutions
          </a>
          <button 
            onClick={scrollToContact}
            className="luxury-gold-button w-full text-center"
          >
            Request a Visual Sample
          </button>
        </div>
      )}
    </motion.nav>
  );
};

export default Navbar;